export const GET_ACCESS_TOKENS = "GET_ACCESS_TOKENS";
export const GET_ACCESS_TOKEN_BY_ID = "GET_ACCESS_TOKEN_BY_ID";
export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
export const DELETE_ACCESS_TOKEN = "DELETE_ACCESS_TOKEN";
export const CREATE_ACCESS_TOKEN = "CREATE_ACCESS_TOKEN";
